import React from "react";
import { useI18n } from "../i18n/LanguageContext";

function Tick() {
  return <div className="w-px h-8 bg-charcoal/40 mx-auto" aria-hidden />;
}

export default function SystemDiagram() {
  const { t } = useI18n();
  const layers = t.layers.items;

  return (
    <div data-testid="system-diagram" className="w-full">
      {/* MEMBER */}
      <div className="flex flex-col items-center">
        <div className="border border-charcoal px-10 py-4 bg-ivory">
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-charcoal">
            {t.diagram.member}
          </span>
        </div>
        <Tick />

        {/* HABITUS */}
        <div className="border border-brass px-14 py-5 bg-ivory">
          <span className="font-headings text-2xl tracking-wide text-charcoal">
            {t.diagram.habitus}
          </span>
        </div>
        <Tick />
      </div>

      {/* horizontal distribution bus */}
      <div className="hidden md:block w-full h-px bg-charcoal/30 mb-0" />

      {/* 8 layers */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-habitus-border border border-habitus-border mt-px">
        {layers.map((l, i) => (
          <div
            key={l.n}
            data-testid={`diagram-layer-${i}`}
            className="bg-ivory p-5 md:p-6 flex flex-col gap-2 hover:bg-habitus-muted/60 transition-colors duration-500"
          >
            <span className="hidden md:block w-px h-5 bg-charcoal/30 mb-1" aria-hidden />
            <span className="font-mono text-[0.65rem] tracking-widest text-brass-muted">{l.n}</span>
            <span className="font-body text-sm font-medium text-charcoal leading-tight">{l.t}</span>
            <span className="font-body text-xs text-charcoal/55 leading-relaxed">{l.d}</span>
          </div>
        ))}
      </div>

      <p className="font-body text-sm text-charcoal/50 mt-8 max-w-2xl mx-auto text-center leading-relaxed">
        {t.diagram.note}
      </p>
    </div>
  );
}
